window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
    ga('send', 'event', 'Klaviyo form', 'form_open', e.detail.formId);
  }
  if (e.detail.type == 'submit') {
    ga('send', 'event', 'Klaviyo form', 'form_submit', e.detail.formId);
  }
  if (e.detail.type == 'close') {
    ga('send', 'event', 'Klaviyo form', 'form_close', e.detail.formId);
  }
});